import * as React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types';

export default function CircularIndeterminate({ isLoading, message = '' }) {
  if (!isLoading) return null;
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        width: '100%',
        height: '100vh',
        zIndex: 999999,
        backgroundColor: 'rgba(224, 224, 224, 0.72)',
      }}
      id="commonLoader"
    >
      <Stack spacing={2} alignItems="center">
        <CircularProgress sx={{ color: '#1a223f' }} />
        {message ? (
          <Typography variant="body1" sx={{ color: 'grey.900', fontWeight: 500 }}>
            {message}
          </Typography>
        ) : null}
      </Stack>
    </Box>
  );
}

CircularIndeterminate.propTypes = {
  isLoading: PropTypes.bool,
  message: PropTypes.string,
};